<full-calendar
  #calendar
  class="calendar"
  [ngClass]="{'calendar--page': pageMode, 'calendar--sidebar': !pageMode}"
  [options]="calendarOptions"
></full-calendar>
